import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="py-12 px-4 md:px-6 bg-background-200/70 border-t border-background-200">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 mb-8">
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 flex items-center justify-center">
              <i className="ri-database-2-line text-lg text-primary-500"></i>
            </div>
            <span className="font-heading text-base font-semibold text-foreground-900">
              BaseTao<span className="text-primary-500">Sheet</span>
            </span>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-5">
            <Link to="/" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap">Home</Link>
            <Link to="/article/basetao-spreadsheet-guide" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap">Guide</Link>
            <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap">Main Website</a>
          </div>
        </div>

        <div className="text-center text-xs text-foreground-500 border-t border-background-300/60 pt-6">
          <p>&copy; {new Date().getFullYear()} BaseTao Spreadsheet Hub. All rights reserved. This is an independent resource website.</p>
        </div>
      </div>
    </footer>
  );
}